import documentfoldersReducer from "./reducers";
export { default as documentfoldersTypes } from "./types";
export { default as documentfoldersOperations } from "./operations";
export default documentfoldersReducer;
